import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ShieldCheck, Bolt, Clock, Award, Truck, Factory, Wrench, Leaf } from 'lucide-react';
import ContactForm from '../components/forms/ContactForm';

const advantages = [
  {
    icon: <ShieldCheck className="w-12 h-12 text-primary-600" />,
    title: 'Пожаробезопасность',
    description: 'Сухие трансформаторы не содержат горючего масла, что исключает риск воспламенения и снижает требования к установке. Идеально подходят для установки в жилых зданиях и промышленных объектах.',
  },
  {
    icon: <Bolt className="w-12 h-12 text-primary-600" />,
    title: 'Экономия 5-10% на электроэнергии',
    description: 'Снижение эксплуатационных затрат благодаря низким потерям холостого хода и короткого замыкания. Окупаемость за счет экономии уже через 3-4 года эксплуатации.',
  },
  {
    icon: <Clock className="w-12 h-12 text-primary-600" />,
    title: 'Производство за 50-75 дней',
    description: 'Сокращенные сроки производства по сравнению с конкурентами (60-90 дней), что позволяет ускорить реализацию проектов и снизить складские издержки.',
  },
  {
    icon: <Award className="w-12 h-12 text-primary-600" />,
    title: 'Гарантия 36 месяцев',
    description: 'Расширенная гарантия на всю продукцию с возможностью продления гарантийного обслуживания. Оперативная техническая поддержка в течение всего срока эксплуатации.',
  },
  {
    icon: <Truck className="w-12 h-12 text-primary-600" />,
    title: 'Доставка по РФ и СНГ',
    description: 'Организуем доставку оборудования в любую точку России и стран СНГ в течение 5-15 дней с момента готовности. Собственная логистическая служба и надежные партнеры.',
  },
  {
    icon: <Factory className="w-12 h-12 text-primary-600" />,
    title: '300+ поставленных трансформаторов',
    description: 'Значительный опыт поставок трансформаторов на различные промышленные и энергетические объекты. Работаем с крупнейшими предприятиями России и СНГ.',
  },
  {
    icon: <Wrench className="w-12 h-12 text-primary-600" />,
    title: 'Простота обслуживания',
    description: 'Минимальные требования к техническому обслуживанию. Отсутствие необходимости в масляном хозяйстве значительно снижает эксплуатационные расходы.',
  },
  {
    icon: <Leaf className="w-12 h-12 text-primary-600" />,
    title: 'Экологичность',
    description: 'Отсутствие масла исключает риск загрязнения окружающей среды. Возможность установки в экологически чувствительных зонах.',
  },
];

export default function AdvantagesPage() {
  return (
    <>
      <Helmet>
        <title>Преимущества трансформаторов ТСЛ и ТСЗ - Проминнова</title>
        <meta name="description" content="Узнайте о преимуществах трансформаторов ТСЛ и ТСЗ от Проминнова: экономия до 10%, пожаробезопасность, срок производства 50-75 дней, гарантия 36 месяцев." />
      </Helmet>

      <div className="bg-primary-50 py-12">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Почему выбирают трансформаторы от Проминнова
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl">
            Наши трансформаторы сочетают в себе высокую надежность, экономичность и современные технические решения
          </p>
        </div>
      </div>

      <div className="container-custom py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {advantages.map((advantage, index) => (
            <div key={index} className="bg-white p-8 rounded-lg shadow-sm border border-gray-100">
              <div className="mb-6">{advantage.icon}</div>
              <h3 className="text-2xl font-bold mb-4">{advantage.title}</h3>
              <p className="text-gray-600">{advantage.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-xl shadow-sm border border-gray-100 p-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            <div>
              <h2 className="text-3xl font-bold mb-4">Получите расчет стоимости трансформатора</h2>
              <p className="text-gray-600 mb-6">
                Заполните форму, и наш менеджер свяжется с вами в течение 2 часов (в рабочее время) с подробным коммерческим предложением.
              </p>
              <div className="space-y-4">
                <div className="flex items-center">
                  <div className="bg-primary-100 text-primary-600 p-2 rounded-full mr-3">
                    <ShieldCheck className="w-5 h-5" />
                  </div>
                  <span>Бесплатная консультация технического специалиста</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-primary-100 text-primary-600 p-2 rounded-full mr-3">
                    <Clock className="w-5 h-5" />
                  </div>
                  <span>Расчет сроков производства и доставки</span>
                </div>
                <div className="flex items-center">
                  <div className="bg-primary-100 text-primary-600 p-2 rounded-full mr-3">
                    <Award className="w-5 h-5" />
                  </div>
                  <span>Индивидуальные условия сотрудничества</span>
                </div>
              </div>
            </div>
            <div>
              <ContactForm buttonText="Получить расчет" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}